import { GET_NOMINATIF, GET_NOMINATIF_SUCCESS, GET_NOMINATIF_FAIL, DELETE_NOMINATIF, DELETE_NOMINATIF_SUCCESS, DELETE_NOMINATIF_FAIL, UPDATE_NOMINATIF, UPDATE_NOMINATIF_SUCCESS, UPDATE_NOMINATIF_FAIL, ADD_NEW_NOMINATIF, ADD_NOMINATIF_SUCCESS, ADD_NOMINATIF_FAIL, NOMINATIF_LOADING, NOMINATIF_RESET } from "./actionType";

export const resetNominatifState = (actionType) => ({
  type: NOMINATIF_RESET,
  payload: { actionType },
});

export const getNominatif = (data) => ({
  type: GET_NOMINATIF,
  payload: data,
});

export const addNewNominatif = (data) => ({
  type: ADD_NEW_NOMINATIF,
  payload: data,
});

export const updateNominatif = (data) => ({
  type: UPDATE_NOMINATIF,
  payload: data,
});

export const deleteNominatif = (data) => ({
  type: DELETE_NOMINATIF,
  payload: data,
});

export const getNominatifSuccess = (data) => ({
  type: GET_NOMINATIF_SUCCESS,
  payload: data,
});

export const getNominatifFail = (error) => ({
  type: GET_NOMINATIF_FAIL,
  payload: error,
});

export const addNominatifSuccess = (data) => ({
  type: ADD_NOMINATIF_SUCCESS,
  payload: data,
});

export const addNominatifFail = (error) => ({
  type: ADD_NOMINATIF_FAIL,
  payload: error,
});

export const updateNominatifSuccess = (data) => ({
  type: UPDATE_NOMINATIF_SUCCESS,
  payload: data,
});

export const updateNominatifFail = (error) => ({
  type: UPDATE_NOMINATIF_FAIL,
  payload: error,
});

export const deleteNominatifSuccess = (data) => ({
  type: DELETE_NOMINATIF_SUCCESS,
  payload: data,
});

export const deleteNominatifFail = (error) => ({
  type: DELETE_NOMINATIF_FAIL,
  payload: error,
});
